__turbopack_context__.v({
  "checked": "EyFyjq_checked",
  "disabled": "EyFyjq_disabled",
  "pill": "EyFyjq_pill",
  "slideInAnimation": "EyFyjq_slideInAnimation",
});
